/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CompanyTemperature {
  Hot = "Hot",
  Warm = "Warm",
  Cold = "Cold",
  Dead = "Dead",
}

export function instanceOfCompanyTemperature(value: any): boolean {
  for (const key in CompanyTemperature) {
    if (Object.prototype.hasOwnProperty.call(CompanyTemperature, key)) {
      if (
        CompanyTemperature[key as keyof typeof CompanyTemperature] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CompanyTemperatureFromJSON(json: any): CompanyTemperature {
  return CompanyTemperatureFromJSONTyped(json, false);
}

export function CompanyTemperatureFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyTemperature {
  return json as CompanyTemperature;
}

export function CompanyTemperatureToJSON(
  value?: CompanyTemperature | null,
): any {
  return value as any;
}

export function CompanyTemperatureToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CompanyTemperature {
  return value as CompanyTemperature;
}
